import { useQuery } from '@tanstack/react-query';

import {
    eventDashboardStatsQueryOptions,
    selectGuestCheckinsStats,
} from '../eventDashboardStatsQueryOptions';

type UseEventDashboardGuestCheckinsOptions = {
    eventId: number | undefined;
    timezone: string;
};

/** Guest Check-ins card hook — shared dashboard cache, `selectGuestCheckinsStats` for the card shape. */
export function useEventDashboardGuestCheckins({
    eventId,
    timezone,
}: UseEventDashboardGuestCheckinsOptions) {
    return useQuery({
        ...eventDashboardStatsQueryOptions({ eventId, timezone }),
        select: selectGuestCheckinsStats,
    });
}
